import { PhxVideoGallery, PhxVideoPlayer } from '@phx-styleguides/als';
import createVueApp from '@phoenix/createVueApp';

document.querySelectorAll('.phoenix-video-gallery').forEach((el) => {
  const app = createVueApp();
  app.component('PhxVideoGallery', PhxVideoGallery);
  app.component('PhxVideoPlayer', PhxVideoPlayer);
  app.mount(el);
});
